<!-- 
Panel for showing the user MFA profile
-->
<template>
  <div>
    <our-loading-indicator v-if="busy"/>
    <div v-else>
      <h3 class="title mt-4 ml-4 pt-2">Details</h3>
      <our-data-container>
        <our-data-field label="First name">{{ user.firstName }}</our-data-field>
        <our-data-field label="Family name">{{ user.familyName }}</our-data-field>
        <our-data-field label="Email">{{ user.emailAddress }}</our-data-field>
      </our-data-container>
      <v-divider />
      <h3 class="title mt-4 ml-4 pt-2">Multi-Factor Authentication</h3>
      <p class="mt-2 ml-4 pt-2">For added security, Multi-Factor Authentication (MFA) is required on your account.
MFA provides an extra layer of protection by requiring a second step when you sign in. By default, MFA is set to use email verification,
but you may choose to set up an authenticator app for quicker access.</p>
      <our-data-container>
        <our-data-field label="Status">{{ user.mfaStatus }}</our-data-field>
      </our-data-container>
    </div>
    <v-container fill-height>
      <v-layout align-center justify-center>
        <v-flex v-if="canSetupAuthenticatorAppMfa" text-xs-center>
          <v-btn @click="showSetupAuthenticatorAppDialog = true">
            <v-icon class="mr-2">phone_android</v-icon>
            Use authenticator app
          </v-btn>
        </v-flex>
        <v-flex v-if="canSetupEmailMfa" text-xs-center>
          <v-btn @click="showSetupEmailMfa = true">
            <v-icon class="mr-2">email</v-icon>
            Use email
          </v-btn>
        </v-flex>
      </v-layout>
    </v-container>
    <v-divider />
    <mfa-setup-authenticator-app-dialog v-model="showSetupAuthenticatorAppDialog" />
    <our-confirmation-dialog v-model="showSetupEmailMfa" title="Switch to email multi-factor authentication" @confirm="setupEmailMfa">
      <p>Are you sure you want to remove the authenticator app and switch to email multi-factor authentication?</p>
    </our-confirmation-dialog>
  </div>
</template>

<script>
import filterMixins from "@/mixins/filter.mixins";
import lookupMixins from "@/mixins/lookup.mixins";
import * as action from "@/store/prisms-users/action-types";
import MfaSetupAuthenticatorAppDialog from "@/components/users/MfaSetupAuthenticatorAppDialog.vue";

export default {
  components: {
    MfaSetupAuthenticatorAppDialog
  },
  mixins: [filterMixins, lookupMixins],
  data() {    
    return {
      showValidationDialog: false,
      showSetupAuthenticatorAppDialog: false,
      showSetupEmailMfa: false
    }
  },
  computed: {
    user() {
      return this.state.data;
    },
    state() {
      return this.$store.state.prismsUsers.viewMfaProfile;
    },
    canSetupAuthenticatorAppMfa()  {
      return this.state.data.canSetupAuthenticatorAppMfa
    },
    canSetupEmailMfa() {
      return this.state.data.canSetupEmailMfa;
    },
    loaded() {
      return this.state.loaded;
    },
    busy() {
      return this.state.loading == true;
    },
    canResetSecondFactor() {
      return this.user.mfaRegistrationStatus != "RESET" || this.user.mfaOptedOut == true || this.user.activeMfaTemporaryBypassValidToDate != null;
    }
  },
  watch: {
    loaded() {
      this.refresh();
    }
  },
  mounted() {
    this.refresh();
  },
  methods: {
    refresh() {
      if (!this.state.loaded && !this.state.loading) {
        this.$store.dispatch(action.VIEW_MFA_PROFILE);
      }
    },
    async setupEmailMfa() {
      await this.$store.dispatch(action.SETUP_EMAIL_MFA);
      this.showSetupEmailMfa = false;
    }
  }
};
</script>
